// ============================================
// COMPONENT - Oferta de imprimir el comprobante justo después de cerrar la caja
// ============================================

import type { TurnoCaja } from '@almacenes/core';
import { ConfirmacionModal } from '../../../components/ConfirmacionModal';
import { usePrintComprobanteTurno } from '../../../hooks/usePrintComprobanteTurno';

interface ImprimirComprobanteTurnoModalProps {
  turno: TurnoCaja;
  onClose: () => void;
}

export const ImprimirComprobanteTurnoModal = ({ turno, onClose }: ImprimirComprobanteTurnoModalProps) => {
  const { imprimirComprobante, imprimiendo } = usePrintComprobanteTurno();

  const handleImprimir = async () => {
    await imprimirComprobante(turno);
    onClose();
  };

  return (
    <ConfirmacionModal
      isOpen
      variant="info"
      title="Caja cerrada"
      message="Cerraste tu caja exitosamente. ¿Quieres imprimir el comprobante del turno?"
      confirmText="Imprimir"
      cancelText="Ahora no"
      isLoading={imprimiendo}
      onConfirm={handleImprimir}
      onClose={onClose}
    />
  );
};
